import { ReactNode } from 'react';

export type PlanRow = {
  label: string;
  standard: ReactNode | string[];
  pro: ReactNode | string[];
  enterprise: ReactNode | string[];
  short?: {
    label?: string;
    standard?: ReactNode | string[];
    pro?: ReactNode | string[];
    enterprise?: ReactNode | string[];
  };
};

export const planRows: PlanRow[] = [
  {
    label: "Who it's for",
    standard: [
      'Small animation teams (4-8)',
      'Teams running limited automation',
      'Layout & blocking workflows',
      'Human-paced creative work',
    ],
    pro: [
      'Production teams running automation',
      'Teams of 8-20 animators',
      'Studios with established workflows',
    ],
    enterprise: [
      'Large animation studios (20-50+ people)',
      'Feature film productions',
      'Multiple concurrent projects',
      'Critical infrastructure',
    ],
  },
  {
    label: 'Concurrent Jobs',
    standard: 'up to 5 parallel jobs',
    pro: 'up to 10 parallel jobs',
    enterprise: 'Unlimited parallel jobs',
    short: {
      label: 'Concurrent jobs',
      standard: '5',
      pro: '10',
      enterprise: 'Unlimited',
    },
  },
  {
    label: 'Batching',
    standard: '50 motions / batch',
    pro: '75 motions / batch',
    enterprise: 'Unlimited batch size',
    short: {
      label: 'Motions per batch',
      standard: '50',
      pro: '75',
      enterprise: 'Unlimited',
    },
  },
  {
    label: 'Character Generation',
    standard: '$2.50/character',
    pro: '$1.85/character',
    enterprise: '$1.23/character',
    short: {
      label: 'Character generation cost',
      standard: '$2.50/gen',
      pro: '$1.85/gen',
      enterprise: '$1.23/gen',
    },
  },
  {
    label: 'Support',
    standard: ['Email & chat support (48hr SLA)', 'Priority feature requests'],
    pro: [
      'Priority email & chat support (24hr SLA)',
      'CI/CD workflow support',
      'Quarterly check-ins',
      'Early access & feature priority',
    ],
    enterprise: [
      'Dedicated Account Manager',
      'White-glove onboarding',
      '4-hr SLA',
      '99.5% uptime SLA',
      'Dedicated Chat channel',
      'Monthly check-ins',
      'Direct roadmap influence',
      'Early beta access to all features',
      'Custom workflows & integrations',
    ],
    short: {
      standard: ['Email Chat (24hr SLA)', 'Priority feature requests'],
      pro: [
        'Priority Email Priority chat (24hr SLA)',
        'CI/CD workflow support',
        'Quarterly check-ins',
        'Early access & feature priority',
      ],
      enterprise: [
        'Dedicated Account Manager',
        'White-glove onboarding',
        '4-hr SLA',
        '99.5% uptime SLA',
        'Dedicated Chat channel',
        'Monthly check-ins',
        'Direct roadmap influence',
        'Early beta access to all features',
        'Custom workflows & integrations',
      ],
    },
  },
  {
    label: 'Usage',
    standard: 'Unlimited',
    pro: 'Unlimited',
    enterprise: 'Unlimited',
  },
  {
    label: 'Price Per second',
    standard: '$0.0390',
    pro: '$0.0290',
    enterprise: '$0.0190',
    short: {
      label: 'Price per second',
      standard: '$0.0390',
      pro: '$0.0290',
      enterprise: '$0.0190',
    },
  },
  {
    label: 'API Access',
    standard: '$300 / mo',
    pro: 'Contact us',
    enterprise: 'Contact us',
  },
];

export const planConfigs = [
  {
    name: 'Standard',
    key: 'standard' as const,
    dotClassName: undefined,
    cardClassName: 'border-gray-30',
  },
  {
    name: 'Pro',
    key: 'pro' as const,
    dotClassName: 'bg-blue-50',
    cardClassName: 'border-blue bg-blue/10',
  },
  {
    name: 'Enterprise',
    key: 'enterprise' as const,
    dotClassName: 'bg-green-50',
    cardClassName: 'border-green-50 bg-green-50/10',
  },
];
